import { BASE_API_URL } from '@/core/config';

export const ENDPOINTS = {
  APPS: {
    STUDY: `${BASE_API_URL}/study/`,
  },
  FCT: {
    ACTIVITY_LOG: `${BASE_API_URL}/activity-log/`,
    APPS: {
      REPORT_ISSUE: `${BASE_API_URL}/apps/report-issue`,
      REPORT_SERVICE_DESK_ISSUE: `${BASE_API_URL}/apps/report-service-desk-issue`,
    },
    CONDITION_TEMPLATE: `${BASE_API_URL}/condition-template/`,
    FORM_STRUCTURE: `${BASE_API_URL}/form-structure/`,
    KEY_IMAGE: {
      BASE: `${BASE_API_URL}/key-image/`,
      RENDERED_SUMMARY: `${BASE_API_URL}/key-image/rendered-summary/`,
    },
    OBSERVATION: `${BASE_API_URL}/text-to-structured-observation/`,
    RENDERED_SUMMARY: {
      BASE: `${BASE_API_URL}/rendered-summary/`,
      REPORT: `${BASE_API_URL}/rendered-summary/report/`,
    },
    REPORT: {
      BASE: `${BASE_API_URL}/report/`,
      STUDY: `${BASE_API_URL}/report/study/`,
    },
    REPORT_FINDING: `${BASE_API_URL}/report-finding/`,
    REPORT_ORGAN: {
      BASE: `${BASE_API_URL}/report-organ/`,
      BULK: `${BASE_API_URL}/report-organ/bulk`,
      FROM_UPDATED_FINDINGS: `${BASE_API_URL}/report-organ/from-updated-findings`,
      REPORT: `${BASE_API_URL}/report-organ/report/`,
    },
    REPORT_PDF: {
      BASE: `${BASE_API_URL}/report-pdf/`,
      STUDY: `${BASE_API_URL}/report-pdf/study/`,
    },
  },
  HI: {
    DICOM: {
      DELETE_SERIES: `${BASE_API_URL}/dicom/deleteSeries`,
      SERIES_QUERY: `${BASE_API_URL}/dicom/series-query`,
      SERIES_RETRIEVE: `${BASE_API_URL}/dicom/series-retrieve`,
    },
    RADIOLOGIST: {
      STUDY: '/radiologist/study/',
    },
    STUDY: `${BASE_API_URL}/study/`,
  },
  PII: {
    PATIENT: `${BASE_API_URL}/userV2/`,
    USER: `${BASE_API_URL}/userV2/current`,
  },
} as const;
